// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2X7p5","label":"Radio_label__2HY8P","checkMark":"Radio_checkMark__3vc2F","disabled":"Radio_disabled__1LJ5S"};